import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { config } from '../../../configs/config';

const KEY = config.aplicacao + '-authToken';

@Injectable({ providedIn: 'root' })
export class TokenService {

    hasToken() {
        return !!this.getToken();
    }

    setToken(token: string) {
        //console.log('setToken', token);        
        window.localStorage.setItem(KEY, token)
    }

    getToken(): any {
        return window.localStorage.getItem(KEY);
    }

    removeToken() {
        // console.log('removeToken');
        window.localStorage.removeItem(KEY);
    }

    getTokenExpirationDate(): Date | null {
        const token = this.getToken();
        if (!token) return null;
        const decoded: any = jwtDecode(token);

        if (decoded.exp === undefined) return null;

        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }

    isTokenExpired(token?: string): boolean {
        if (!token) {
            const storedToken = this.getToken();
            token = storedToken === null ? undefined : storedToken;
        }
        if (!token) return true;

        const date = this.getTokenExpirationDate();
        if (!date) return true;
        return !(date.valueOf() > new Date().valueOf());
    }
}